import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
// import { Helmet } from 'react-helmet';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Container, Typography, CircularProgress, IconButton } from '@mui/material';
import { makeStyles, Grid } from '@material-ui/core';
import Parser from 'html-react-parser';
import removeImages from './removeImagens';
import { useDevice } from 'components/DeviceContext.js';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        minHeight: '100vh',
    },
    backButton: {
        marginBottom: theme.spacing(2),
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'justify',
        marginTop: theme.spacing(2),
    },
    image: {
        maxWidth: '100%',
        maxHeight: '300px',
        marginBottom: theme.spacing(2),
    },
}));

const LerNoticia = () => {
    const { noticiaId } = useParams();
    const navigate = useNavigate();
    const [noticia, setNoticia] = useState(null);
    const [loading, setLoading] = useState(true);
    const classes = useStyles();
    const { isMobile, isLaptop } = useDevice();

    useEffect(() => {
        const fetchNoticia = async () => {
            try {
                const response = await axios.get(`https://cnm.org.br/api/noticias/${noticiaId}`);

                const noticiaData = response.data.noticia;
                if (noticiaData.imagem && !noticiaData.imagem.startsWith('http') && !noticiaData.imagem.startsWith('www')) {
                    noticiaData.imagem = `https://cnm.org.br${noticiaData.imagem}`;
                }

                setNoticia(noticiaData);
                setLoading(false);
            } catch (error) {
                console.error('Erro ao buscar detalhes da notícia:', error);
                setLoading(false);
            }
        };

        fetchNoticia();
    }, [noticiaId]);

    const handleBack = () => {
        navigate(-1);
    };

    const handleShareTwitter = () => {
        window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(noticia.titulo)}&url=${encodeURIComponent(window.location.href)}`);
    };

    const handleShareInstagram = () => {
        window.open(`https://www.instagram.com/`);
    };

    const handleShareWhatsApp = () => {
        window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(noticia.titulo)}%20${encodeURIComponent(window.location.href)}`);
    };

    const handleShareFacebook = () => {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}&quote=${encodeURIComponent(noticia.titulo)}`);
    };

    if (loading) {
        return (
            <div className={classes.root}>
                <CircularProgress />
            </div>
        );
    }

    if (!noticia) {
        return (
            <div className={classes.root}>
                <Typography variant="h5">Notícia não encontrada</Typography>
            </div>
        );
    }

    return (
        <Container className={classes.root} style={{ padding: isMobile ? '1em' : '6em' }}>
            {/* <Helmet>
                <title>{noticia.titulo}</title>
                <meta property="og:title" content={noticia.titulo} />
                <meta property="og:description" content={removeImages(noticia.conteudo, 0).substring(0, 150)} />
                <meta property="og:image" content={noticia.imagem} />
                <meta property="og:url" content={window.location.href} />
                <meta name="twitter:card" content="summary_large_image" />
            </Helmet> */}
            <IconButton onClick={handleBack} className={classes.backButton}>
                <ArrowBackIcon />
            </IconButton>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                <p>Compartilhar:</p>
                <Button startIcon={<TwitterIcon />} onClick={handleShareTwitter} />
                <Button startIcon={<FacebookIcon />} onClick={handleShareFacebook} />
                <Button startIcon={<InstagramIcon />} onClick={handleShareInstagram} />
                <Button startIcon={<WhatsAppIcon />} onClick={handleShareWhatsApp} />
            </div>
            <Typography variant="h4" gutterBottom style={{ fontSize: isMobile ? '24px' : isLaptop ? '26px' : '25px' }}>{noticia.titulo}</Typography>
            <Grid align="center">
                <img src={noticia.imagem} alt="Imagem da Notícia" className={classes.image} style={{ padding: isMobile ? '' : '2em' }} />
            </Grid>
            <Grid align="right">
                <Typography variant="body1" gutterBottom>{noticia.datetime}</Typography>
            </Grid>
            <Typography variant="subtitle1" gutterBottom>{noticia.data}</Typography>
            <Typography variant="body2" color="textSecondary" component="div" className={classes.content}>
                {Parser(removeImages(noticia.conteudo, 0))}
            </Typography>
        </Container>
    );
};

export default LerNoticia;

